/* AquaSound — interacciones propias (prefijo aq-). Sin librerías externas. */
(function () {
  'use strict';
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Revelado al hacer scroll (un único observador compartido) */
  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.aq-reveal:not(.aq-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('aq-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('aq-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Cifras que cuentan hacia arriba */
  function initCifras(raiz) {
    var els = (raiz || document).querySelectorAll('[data-aq-contar]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-aq-contar')) || 0;
      var pre = el.getAttribute('data-aq-prefijo') || '';
      var suf = el.getAttribute('data-aq-sufijo') || '';
      if (reducido) { el.textContent = pre + fin + suf; return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        el.textContent = pre + v + suf;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Escena fija: cambia la imagen según el texto que está en pantalla */
  function initMomentos(raiz) {
    (raiz || document).querySelectorAll('[data-aq-momentos]').forEach(function (bloque) {
      var pasos = bloque.querySelectorAll('.aq-momento');
      var imgs = bloque.querySelectorAll('.aq-momentos__imgs img');
      if (!pasos.length || !('IntersectionObserver' in window)) return;
      function activar(i) {
        pasos.forEach(function (p, j) { p.classList.toggle('aq-activa', i === j); });
        imgs.forEach(function (im, j) { im.classList.toggle('aq-activa', i === j); });
      }
      activar(0);
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) activar(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  /* Burbujas del hero */
  function initBurbujas(raiz) {
    (raiz || document).querySelectorAll('[data-aq-burbujas]').forEach(function (cont) {
      if (cont.childElementCount || reducido) return;
      var n = parseInt(cont.getAttribute('data-aq-burbujas'), 10) || 0;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('span');
        var tam = 10 + Math.random() * 46;
        b.style.width = b.style.height = tam + 'px';
        b.style.left = (Math.random() * 100) + '%';
        b.style.animationDuration = (9 + Math.random() * 12) + 's';
        b.style.animationDelay = (-Math.random() * 18) + 's';
        cont.appendChild(b);
      }
    });
  }

  /* Página de producto: galería, variantes, cantidad, carrito */
  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-aq-producto]').forEach(function (cont) {
      var principal = cont.querySelector('.aq-galeria-p__principal img');
      var minis = cont.querySelectorAll('.aq-galeria-p__minis button');
      var actual = 0;
      function mostrar(i) {
        if (!principal || !minis.length) return;
        actual = (i + minis.length) % minis.length;
        var b = minis[actual];
        principal.classList.add('aq-cambiando');
        var nueva = new Image();
        nueva.onload = function () {
          principal.src = b.getAttribute('data-aq-src');
          principal.srcset = b.getAttribute('data-aq-srcset') || '';
          principal.alt = b.getAttribute('data-aq-alt') || '';
          principal.classList.remove('aq-cambiando');
        };
        nueva.src = b.getAttribute('data-aq-src');
        minis.forEach(function (m, j) { m.classList.toggle('aq-activa', j === actual); });
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { mostrar(i); }); });
      var prev = cont.querySelector('[data-aq-prev]');
      var next = cont.querySelector('[data-aq-next]');
      if (prev) prev.addEventListener('click', function () { mostrar(actual - 1); });
      if (next) next.addEventListener('click', function () { mostrar(actual + 1); });

      var form = cont.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var inputId = form.querySelector('input[name="id"]');
      var boton = form.querySelector('[data-aq-boton]');
      var textoBoton = boton ? boton.querySelector('[data-aq-boton-texto]') : null;
      var precio = cont.querySelector('[data-aq-precio]');
      var tachado = cont.querySelector('[data-aq-tachado]');
      var ahorro = cont.querySelector('[data-aq-ahorro]');
      var error = cont.querySelector('.aq-compra__error');
      var datos = cont.querySelector('[data-aq-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var formato = cont.getAttribute('data-aq-formato') || '{{amount_with_comma_separator}} €';

      function dinero(cent) {
        var n = (cent / 100);
        var conComa = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        var conPunto = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n).toString())
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
          .replace(/\{\{\s*amount\s*\}\}/, conPunto);
      }

      cont.querySelectorAll('.aq-opcion input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var elegidas = [];
          cont.querySelectorAll('.aq-opcion').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            elegidas.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) {
            return x.options.every(function (o, i) { return o === elegidas[i]; });
          });
          if (!v) {
            if (boton) boton.disabled = true;
            if (textoBoton) textoBoton.textContent = boton.getAttribute('data-aq-no-disponible');
            return;
          }
          inputId.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) {
            var hay = v.compare_at_price && v.compare_at_price > v.price;
            tachado.hidden = !hay;
            if (hay) tachado.textContent = dinero(v.compare_at_price);
            if (ahorro) {
              ahorro.hidden = !hay;
              if (hay) ahorro.textContent = ahorro.getAttribute('data-aq-plantilla').replace('[porcentaje]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
            }
          }
          if (boton) boton.disabled = !v.available;
          if (textoBoton) textoBoton.textContent = v.available ? boton.getAttribute('data-aq-texto') : boton.getAttribute('data-aq-agotado');
          if (v.featured_media_index != null && minis[v.featured_media_index]) mostrar(v.featured_media_index);
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });

      var cant = cont.querySelector('.aq-cantidad input');
      cont.querySelectorAll('[data-aq-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          cant.value = Math.max(1, v + parseInt(b.getAttribute('data-aq-cant'), 10));
        });
      });

      form.addEventListener('submit', function (ev) {
        var cajon = document.querySelector('cart-drawer');
        if (!cajon || typeof cajon.renderContents !== 'function' || !window.fetch) return; // envío normal
        ev.preventDefault();
        if (boton) boton.setAttribute('aria-busy', 'true');
        if (error) error.textContent = '';
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { if (error) error.textContent = res.description || res.message || ''; return; }
          cajon.classList.remove('is-empty');
          cajon.renderContents(res);
        }).catch(function () { form.submit(); })
          .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
      });

      var barra = cont.querySelector('.aq-barra-fija');
      var zonaBoton = cont.querySelector('.aq-compra__filas');
      if (barra && zonaBoton && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) {
          var arriba = e[0].boundingClientRect.top < 0;
          barra.classList.toggle('aq-visible', !e[0].isIntersecting && arriba);
        });
        io.observe(zonaBoton);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () {
          if (boton && !boton.disabled) { form.requestSubmit ? form.requestSubmit(boton) : boton.click(); }
        });
      }
    });
  }

  function iniciar(raiz) {
    initBurbujas(raiz);
    initReveals(raiz);
    initCifras(raiz);
    initMomentos(raiz);
    initProducto(raiz);
  }

  document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  /* Editor de Shopify: re-iniciar al añadir o cambiar secciones */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
